<template>
    <MapPin :map="map" :coords="location.coords" @markerSet="handleMarker">
        <div class="posfinder-screen__pin" :class="wrapperClass" @click.prevent="$emit('click')">
            <div class="posfinder-screen__pin-content">
                <div class="posfinder-screen__pin-content-close" @click.prevent="clearFocus"></div>

                <p class="h4 posfinder-screen__headline">
                    {{ location.title }}
                </p>
                <p class="secondaryfont-regular posfinder-screen__text">
                    {{ location.street }} {{ location.no }}<br/>
                    {{ location.zip }} {{ location.city }}
                </p>
                <button class="posfinder-screen__navlink button button--gray" @click.prevent="openLocationLink">
                    zu Google Maps
                </button>
            </div>
        </div>
    </MapPin>
</template>

<script>
import MapPin from "./MapPin";
import {trackingPushLocationGmapLink} from "../../tracking";
import {getNavLink} from "../../scripts/gMap";

export default {
    name: "LocationPin",
    components: {MapPin},
    props: {
        map: {
            type: Object,
            required: true
        },
        location: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            marker: null
        }
    },
    watch: {
        location: {
            deep: true,
            handler: 'focusPin'
        }
    },
    computed: {
        wrapperClass() {
            const className = [];
            className.push('posfinder-screen__pin--' + this.location.type);
            if (this.location.focus) {
                className.push('posfinder-screen__pin--focus');
            }
            return className.join(' ');
        }
    },
    mounted() {
        this.focusPin();
    },
    methods: {
        handleMarker(marker) {
            this.marker = marker;
            this.$emit('markerSet', marker);
        },
        clearFocus(event) {
            this.$store.commit('clearResultFocus');
            this.$emit('markerSet');
            event.stopPropagation();
        },
        focusPin() {
            if (this.location.focus && this.$store.state.focusId !== this.location.id) {
                this.$store.commit('setFocus', this.location.id);
                this.map.focusCoords(this.location.coords);
            }
        },
        openLocationLink() {
            trackingPushLocationGmapLink(this.location);
            window.open(getNavLink(this.location.coords.lat, this.location.coords.lon), '_blank');
        }
    }
}
</script>
